<div class="rk" [class.pantalla-completa]="vistaPrevia || !!nuevo">

  <!-- ==================== Alta de riesgo, a pantalla completa ====================
       Mismo trato que el editor de Activos: el formulario es largo y encajado
       entre las tarjetas obliga a desplazarse mientras se captura. -->
  <ng-container *ngIf="nuevo && !vistaPrevia">
    <div class="rk-panel">
      <div class="rk-card edicion">
        <div class="rk-card-cab">
          <span class="rk-folio">Nuevo riesgo</span>
          <span class="rk-hint-mini">El folio se asigna solo al guardar, con la clave de esta matriz.</span>
          <span class="rk-espacio"></span>
          <button *ngIf="puedeEditar" type="button" class="rk-btn-ok" (click)="guardarNuevo()" [disabled]="guardandoNuevo">
            {{ guardandoNuevo ? 'Guardando…' : 'Guardar' }}
          </button>
          <button *ngIf="puedeEditar" type="button" class="rk-btn-sec" (click)="cancelarNuevo()" [disabled]="guardandoNuevo">
            Cancelar
          </button>
        </div>
        <ng-container *ngTemplateOutlet="formulario; context: { $implicit: nuevo }"></ng-container>
      </div>
    </div>
  </ng-container>

  <!-- ==================== Vista de tarjetas ==================== -->
  <ng-container *ngIf="!vistaPrevia && !nuevo">
   <div class="rk-panel">

    <div class="rk-barra">
      <div>
        <strong>Riesgos de proceso</strong>
        <span class="rk-hint">
          Riesgos de la operación, no de un activo. Cada tarjeta muestra cómo se evaluó el riesgo
          al detectarlo (<b>severidad = probabilidad &times; impacto</b>, de 1 a 16), el plan para
          reducirlo y cómo queda una vez aplicado.
        </span>
      </div>
      <div class="rk-acciones">
        <!-- Los criterios con los que se evalúa, antes del alta: es lo que hay
             que tener a la vista al capturar probabilidad e impacto. -->
        <button type="button" class="rk-btn-criterios" (click)="abrirCriterios()"
                matTooltip="Probabilidad, impacto y bandas de severidad del formato">
          Criterios de evaluación
        </button>
        <span class="rk-solo-lectura" *ngIf="!puedeEditar"
              matTooltip="El plan de gestión es parte del documento certificable: sólo el perfil de edición puede cambiarlo.">
          Sólo lectura
        </span>
        <button *ngIf="puedeEditar" type="button" class="rk-btn-pri" (click)="agregarRiesgo()"
                [disabled]="hayEdicionAbierta" [title]="avisoAgregar()">
          + Agregar riesgo
        </button>
        <button type="button" class="rk-btn-sec" (click)="alternarVista()"
                matTooltip="La hoja tal como se ve en el Excel oficial, a pantalla completa. Solo lectura.">
          Ver formato FOS-005
        </button>
        <button *ngIf="puedeEditar" type="button" class="rk-btn-sec" (click)="alternarPapelera()"
                matTooltip="Riesgos eliminados que todavía se pueden restaurar, con su folio y sus cortes.">
          {{ papeleraAbierta ? 'Ocultar eliminados' : 'Eliminados' }}
        </button>
      </div>
    </div>

    <!-- ===== Papelera: lo eliminado que todavía se puede resucitar ===== -->
    <div class="rk-papelera" *ngIf="papeleraAbierta">
      <div class="rk-papelera-cab">
        <strong>Riesgos eliminados</strong>
        <span class="rk-hint-mini">
          Vuelven con su folio y sus cortes de seguimiento. Como regresan con sus mismos
          identificadores, sus evidencias quedan ligadas solas.
        </span>
      </div>

      <div class="rk-bit-cargando" *ngIf="cargandoPapelera">Cargando…</div>

      <ng-container *ngIf="!cargandoPapelera">
        <div class="rk-bit-vacio" *ngIf="papelera.length === 0">
          No hay riesgos eliminados. Aquí aparecen en cuanto se borre alguno.
        </div>

        <div class="rk-bit rk-resp" *ngFor="let c of papelera">
          <div class="rk-bit-cuerpo-txt">
            <div class="rk-bit-cab">
              <strong>{{ c.referencia || 'Sin folio' }}</strong>
              <span class="rk-bit-quien" *ngIf="c.usuarioNombre">Lo eliminó {{ c.usuarioNombre }}</span>
              <span class="rk-bit-fecha">{{ c.fecha | fechaBitacora }}</span>
            </div>
            <div class="rk-bit-valores" *ngIf="c.resumen">
              <span class="rk-bit-antes">{{ c.resumen }}</span>
            </div>
          </div>
          <button *ngIf="puedeEditar" type="button" class="rk-btn-sec mini"
                  (click)="restaurarEliminado(c)"
                  [disabled]="restaurandoPapelera.has(c.idRespaldo!)">
            {{ restaurandoPapelera.has(c.idRespaldo!) ? 'Restaurando…' : 'Restaurar' }}
          </button>
        </div>
      </ng-container>
    </div>

    <!-- Filtro por severidad -->
    <div class="rk-filtros" *ngIf="!cargando && riesgos.length > 0">
      <span class="rk-filtros-et">Severidad</span>
      <button type="button" class="rk-chip-f" [class.activo]="filtro === 'Todas'" (click)="filtro = 'Todas'">
        Todas <span class="rk-n">{{ riesgos.length }}</span>
      </button>
      <button type="button" *ngFor="let b of bandas" class="rk-chip-f"
              [ngClass]="claseSeveridad(b)" [class.activo]="filtro === b" (click)="filtro = b">
        {{ etiquetaBanda(b) }} <span class="rk-n">{{ conteo(b) }}</span>
      </button>
    </div>

    <!-- Aviso de cortes sin resultado. Desaparece solo cuando no queda ninguno. -->
    <div class="rk-aviso" *ngIf="!cargando && totalPendientes > 0">
      <span class="rk-aviso-icono">!</span>
      <div>
        <strong>{{ totalPendientes }} corte(s) de monitoreo sin resultado</strong>
        en {{ foliosPendientes }}.
        <span class="rk-aviso-como">
          Abre <b>Monitoreo</b> en cada uno: el corte en rojo es el que falta.
          Dale <b>Editar</b> y escribe lo que realmente pasó en ese periodo.
        </span>
      </div>
    </div>

    <div class="rk-cargando" *ngIf="cargando">Cargando…</div>

    <div class="rk-vacio" *ngIf="!cargando && riesgos.length === 0 && !nuevo">
      Sin riesgos de proceso.
      <button *ngIf="puedeEditar" type="button" class="rk-btn-sec" (click)="agregarRiesgo()"
              [disabled]="hayEdicionAbierta" [title]="avisoAgregar()">+ Agregar el primero</button>
    </div>
    <div class="rk-vacio" *ngIf="!cargando && riesgos.length > 0 && filtrados.length === 0">
      Ningún riesgo con severidad {{ etiquetaBanda(filtro) }}.
    </div>

    <!-- ===== Una tarjeta por riesgo ===== -->
    <!-- Con !cargando: durante una recarga las tarjetas viejas seguirian
         aceptando clics sobre datos que estan a punto de ser reemplazados. -->
    <div class="rk-card" *ngFor="let r of filtrados"
         [id]="'rsk-' + r.idRiesgoProceso"
         [class.enfocado]="enfocado === r.idRiesgoProceso"
         [ngClass]="claseSeveridad(r.clasificacionInicial)"
         [class.edicion]="enEdicion(r)" [hidden]="cargando">

      <div class="rk-card-cab">
        <button type="button" class="rk-caret-btn" (click)="alternarTarjeta(r)"
                [title]="expandido(r) ? 'Contraer' : 'Ver detalle'">
          {{ expandido(r) ? '▾' : '▸' }}
        </button>
        <span class="rk-folio">{{ r.consecutivo }}</span>
        <span class="rk-pill" *ngIf="r.estatus === 'ACTIVO'">En seguimiento</span>
        <span class="rk-tag" *ngIf="r.estrategia">{{ r.estrategia }}</span>
        <!-- Se ve sin desplegar nada: así se sabe en qué riesgo falta capturar. -->
        <span class="rk-pill falta" *ngIf="pendientes(r) > 0">
          {{ pendientes(r) }} sin resultado
        </span>
        <!-- Aviso de monitoreo (29/09/2026): se ve sin desplegar nada. -->
        <ng-container *ngIf="r.estatus === 'ACTIVO' && proximo(r) as p">
          <span class="rk-pill aviso-vencido" *ngIf="p.estado === 'VENCIDO'" [title]="p.detalle">{{ p.texto }}</span>
          <span class="rk-pill aviso-pronto" *ngIf="p.estado === 'POR_VENCER'" [title]="p.detalle">{{ p.texto }}</span>
        </ng-container>
        <!-- Contraída, el encabezado tiene que bastar para saber cómo va. -->
        <span class="rk-cab-sev" *ngIf="!expandido(r)">
          <span class="rk-n-mini" [ngClass]="claseSeveridad(r.clasificacionInicial)">
            {{ r.severidadInicial ?? '—' }}
          </span>
          <span class="rk-cab-flecha">&rarr;</span>
          <span class="rk-n-mini" [ngClass]="claseSeveridad(r.clasificacionReevaluada)">
            {{ r.severidadReevaluada ?? '—' }}
          </span>
        </span>
        <span class="rk-espacio"></span>
        <ng-container *ngIf="!enEdicion(r)">
          <!-- Expediente del riesgo: SOLO en las matrices que no trabajan con
               activos. En las que sí —hoy la de IA— el expediente vive en la
               pestaña de Activos, colgado del activo, que es donde está la
               trazabilidad completa; aquí sobraría.
               No se bloquea con la edición: es de sólo lectura. -->
          <button type="button" class="rk-btn-sec mini" *ngIf="!conActivos"
                  (click)="abrirExpediente(r)"
                  title="Todo lo relacionado con este riesgo en una sola ventana: su plan de acción, sus cortes de monitoreo, sus evidencias y su bitácora.">
            Expediente
          </button>
          <!-- Bloqueados mientras otra tarjeta tenga una edición abierta. -->
          <button *ngIf="puedeEditar" type="button" class="rk-btn-sec mini" (click)="editar(r)"
                  [disabled]="bloqueado(r)"
                  [title]="bloqueado(r) ? avisoBloqueo() : ''">
            Editar
          </button>
          <button *ngIf="puedeEditar" type="button" class="rk-btn-rojo mini" (click)="eliminar(r)"
                  [disabled]="bloqueado(r)"
                  [title]="bloqueado(r) ? avisoBloqueo() : ''">
            Eliminar
          </button>
        </ng-container>
        <ng-container *ngIf="enEdicion(r)">
          <button *ngIf="puedeEditar" type="button" class="rk-btn-ok" (click)="guardarEdicion(r)"
                  [disabled]="guardando.has(r.idRiesgoProceso!)">
            {{ guardando.has(r.idRiesgoProceso!) ? 'Guardando…' : 'Guardar' }}
          </button>
          <button *ngIf="puedeEditar" type="button" class="rk-btn-sec" (click)="cancelarEdicion(r)"
                  [disabled]="guardando.has(r.idRiesgoProceso!)">
            Cancelar
          </button>
        </ng-container>
      </div>

      <!-- ----- Lectura ----- -->
      <ng-container *ngIf="!enEdicion(r) && expandido(r)">

        <div class="rk-desc">{{ descripcionLimpia(r) }}</div>

        <!-- Antes y después, en una franja compacta -->
        <div class="rk-eval">
          <div class="rk-eval-caja">
            <div class="rk-eval-tit">Al detectarlo</div>
            <div class="rk-eval-fila">
              <span class="rk-sev" [ngClass]="claseSeveridad(r.clasificacionInicial)"
                    [matTooltip]="r.criterioAceptacion || ''">
                <span class="rk-sev-num">{{ r.severidadInicial ?? '—' }}</span>
                <span class="rk-sev-de">de 16</span>
              </span>
              <span class="rk-eval-txt">
                <span class="rk-eval-banda">
                  {{ etiquetaBanda(r.clasificacionInicial) || 'Por calcular' }}
                </span>
                <span class="rk-eval-formula" *ngIf="r.probInicial && r.impactoInicial">
                  {{ etiqueta('PROBABILIDAD', r.probInicial) }} ({{ r.probInicial }})
                  &times; {{ etiqueta('IMPACTO', r.impactoInicial) }} ({{ r.impactoInicial }})
                </span>
              </span>
            </div>
          </div>

          <div class="rk-flecha">
            <span class="rk-flecha-simbolo">&rarr;</span>
            <span class="rk-mejora baja" *ngIf="(mejora(r) ?? 0) > 0">bajó {{ mejora(r) }}</span>
            <span class="rk-mejora igual" *ngIf="mejora(r) === 0">sin cambio</span>
            <span class="rk-mejora sube" *ngIf="(mejora(r) ?? 0) < 0">subió {{ -mejora(r)! }}</span>
          </div>

          <div class="rk-eval-caja azul">
            <div class="rk-eval-tit">Tras el plan</div>
            <div class="rk-eval-fila">
              <span class="rk-sev" [ngClass]="claseSeveridad(r.clasificacionReevaluada)">
                <span class="rk-sev-num">{{ r.severidadReevaluada ?? '—' }}</span>
                <span class="rk-sev-de">de 16</span>
              </span>
              <span class="rk-eval-txt">
                <span class="rk-eval-banda">
                  {{ etiquetaBanda(r.clasificacionReevaluada) || 'Por reevaluar' }}
                </span>
                <span class="rk-eval-formula" *ngIf="r.probReevaluada && r.impactoReevaluado">
                  {{ etiqueta('PROBABILIDAD', r.probReevaluada) }} ({{ r.probReevaluada }})
                  &times; {{ etiqueta('IMPACTO', r.impactoReevaluado) }} ({{ r.impactoReevaluado }})
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="rk-campos">
          <div class="rk-campo doble">
            <div class="rk-et">Causa raíz — ¿qué lo origina?</div>
            <div class="rk-val">{{ r.causaRaiz || '—' }}</div>
          </div>
          <div class="rk-campo doble">
            <div class="rk-et">Plan de acción</div>
            <div class="rk-val">{{ r.acciones || '—' }}</div>
          </div>
          <div class="rk-campo doble">
            <div class="rk-et">Responsable / recursos</div>
            <div class="rk-val">{{ r.responsableRecursos || '—' }}</div>
          </div>

          <div class="rk-campo">
            <div class="rk-et">Fecha de identificación</div>
            <div class="rk-val">{{ (r.fechaIdentificacion | date: 'dd/MM/yyyy') || '—' }}</div>
          </div>
          <div class="rk-campo">
            <div class="rk-et">Periodicidad de monitoreo</div>
            <div class="rk-val">{{ r.periodicidad || '—' }}</div>
          </div>
          <div class="rk-campo" *ngIf="r.estatus === 'ACTIVO' && proximo(r) as p">
            <div class="rk-et">Próximo monitoreo</div>
            <div class="rk-val rk-proximo" [ngClass]="'es-' + p.estado">{{ p.detalle }}</div>
          </div>
          <div class="rk-campo">
            <div class="rk-et">Fase de detección</div>
            <div class="rk-val">{{ r.faseDeteccion || '—' }}</div>
          </div>
          <div class="rk-campo" *ngIf="listaActivos(r).length > 0">
            <div class="rk-et">Activos evaluados</div>
            <div class="rk-chips">
              <span class="rk-tag azul" *ngFor="let a of listaActivos(r)">{{ a }}</span>
            </div>
          </div>
        </div>

      </ng-container>

      <!-- ----- Edición ----- -->
      <ng-container *ngIf="enEdicion(r)">
        <ng-container *ngTemplateOutlet="formulario; context: { $implicit: borrador(r) }"></ng-container>
      </ng-container>

      <!-- ----- Monitoreo -----
           Va fuera del if de lectura: cada corte se guarda por su cuenta, así
           que también se puede registrar mientras se edita el riesgo. Antes
           quedaba escondido en cuanto se abría el formulario. -->
        <div class="rk-cortes" *ngIf="expandido(r)">
          <button type="button" class="rk-cortes-toggle" (click)="alternarCortes(r)">
            <span class="rk-caret">{{ abiertos.has(r.idRiesgoProceso!) ? '▾' : '▸' }}</span>
            Monitoreo
            <span class="rk-n">{{ r.seguimientos?.length || 0 }} cortes</span>
            <span class="rk-pill falta" *ngIf="pendientes(r) > 0">{{ pendientes(r) }} sin resultado</span>
          </button>

          <div class="rk-linea" *ngIf="abiertos.has(r.idRiesgoProceso!)"
               [class.sin-cortes]="!r.seguimientos || r.seguimientos.length === 0">
            <!-- Alta de corte: arriba, porque el corte nuevo es el más reciente
                 y la línea va del más reciente al más antiguo (29/09/2026). -->
            <div class="rk-corte alta" *ngIf="enEdicion(r) && nuevoCorte[r.idRiesgoProceso!]">
              <span class="rk-punto nuevo"></span>
              <div class="rk-corte-cuerpo">
                <div class="rk-corte-form">
                  <input type="date" class="i fecha" aria-label="Fecha del corte"
                         [min]="minNuevoCorte(r)"
                         [(ngModel)]="nuevoCorte[r.idRiesgoProceso!].fechaMonitoreo" />
                  <input class="i" aria-label="Qué se encontró en este corte (si no se revisó, escribe NA y la razón)"
                         placeholder="Qué se encontró en este corte (si no se revisó, escribe NA y la razón)"
                         [maxlength]="lim.corte.resultado" [(ngModel)]="nuevoCorte[r.idRiesgoProceso!].resultado" />
                  <button *ngIf="puedeEditar" type="button" class="rk-btn-sec mini" (click)="agregarCorte(r)"
                          [disabled]="guardandoCorte.has(r.idRiesgoProceso!)">
                    {{ guardandoCorte.has(r.idRiesgoProceso!) ? 'Guardando…' : '+ Agregar corte' }}
                  </button>
                </div>
                <div class="rk-corte-ayuda">
                  Cada corte agrega su pareja de columnas —Fecha y Resultado— en el formato
                  FOS-005, y así sucesivamente. Se guarda al momento, aparte del riesgo.
                </div>
              </div>
            </div>
            <div class="rk-corte" *ngFor="let s of cortesRecientes(r); let primero = first"
                 [class.ultimo]="primero"
                 [class.pendiente]="esPendiente(s.resultado) && !editandoCorte(s)"
                 [class.editando]="editandoCorte(s)">
              <span class="rk-punto"></span>

              <!-- ----- Lectura ----- -->
              <div class="rk-corte-cuerpo" *ngIf="!editandoCorte(s)">
                <div class="rk-corte-cab">
                  <strong>{{ s.fechaMonitoreo | date: 'dd/MM/yyyy' }}</strong>
                  <span class="rk-pill ultimo" *ngIf="primero">Último monitoreo</span>
                  <span class="rk-corte-quien" *ngIf="s.usuarioNombre">· {{ s.usuarioNombre }}</span>
                  <span class="rk-pill falta" *ngIf="esPendiente(s.resultado)">Falta el resultado</span>
                  <span class="rk-espacio"></span>
                  <!-- La línea de tiempo NO se corrige ni se borra: es el
                       historial del monitoreo y cada corte dice lo que se
                       encontró en su fecha. La única excepción son los cortes
                       que nunca llegaron a tener resultado —vienen así del
                       FOS-005 original—, que sí se pueden completar. -->
                  <button type="button" class="rk-btn-sec mini"
                          *ngIf="puedeEditar && (enEdicion(r) && esPendiente(s.resultado))"
                          (click)="editarCorte(r, s)">
                    Capturar resultado
                  </button>
                </div>
                <div class="rk-corte-txt">{{ s.resultado }}</div>
              </div>

              <!-- ----- Corrección en el mismo renglón ----- -->
              <div class="rk-corte-cuerpo" *ngIf="editandoCorte(s)">
                <div class="rk-corte-form">
                  <!-- La fecha no se edita: es el dato de registro del corte.
                       Solo se corrige la redacción del resultado. -->
                  <span class="rk-fecha-fija" title="La fecha del corte no se modifica una vez registrado">
                    {{ s.fechaMonitoreo | date: 'dd/MM/yyyy' }}
                  </span>
                  <input class="i" placeholder="Qué se encontró en este corte" aria-label="Qué se encontró en este corte"
                         [maxlength]="lim.corte.resultado" [(ngModel)]="borradorCorte(s).resultado" />
                  <button *ngIf="puedeEditar" type="button" class="rk-btn-ok" (click)="guardarEdicionCorte(s)"
                          [disabled]="guardandoEdicionCorte.has(s.idRpSeguimiento!)">
                    {{ guardandoEdicionCorte.has(s.idRpSeguimiento!) ? 'Guardando…' : 'Guardar' }}
                  </button>
                  <button *ngIf="puedeEditar" type="button" class="rk-btn-sec mini" (click)="cancelarEdicionCorte(s)"
                          [disabled]="guardandoEdicionCorte.has(s.idRpSeguimiento!)">
                    Cancelar
                  </button>
                </div>
                <div class="rk-corte-ayuda">
                  Solo se corrige el texto del resultado. La fecha del corte y quién lo
                  capturó quedan como se registraron.
                </div>
              </div>
            </div>

            <div class="rk-corte-vacio" *ngIf="!r.seguimientos || r.seguimientos.length === 0">
              Sin cortes registrados.
            </div>
          </div>
        </div>

      <!-- ----- Bitácora -----
           Se pide al desplegarla, no al cargar: es una petición por riesgo
           para algo que casi nunca se abre. -->
        <!-- ===== Evidencias adjuntas ===== -->
        <!-- Marcadas como "No aplica": solo una línea discreta, reversible. -->
        <div class="rk-evidencias na" *ngIf="expandido(r) && evidenciaAplica[r.idRiesgoProceso!] === 'NO'">
          <span class="rk-evd-na">
            Evidencias: <b>No aplica</b> para este riesgo
          </span>
          <button *ngIf="puedeEditar" type="button" class="rk-btn-sec mini" (click)="marcarSiAplicaEvidencias(r)"
                  [disabled]="!enEdicion(r)" [title]="avisoSoloEdicion(r)">
            Cambiar a Sí aplica
          </button>
        </div>

        <div class="rk-evidencias" *ngIf="expandido(r) && evidenciaAplica[r.idRiesgoProceso!] !== 'NO'">
          <button type="button" class="rk-cortes-toggle" (click)="alternarEvidencias(r)">
            <span class="rk-caret">{{ evidenciasAbiertas.has(r.idRiesgoProceso!) ? '▾' : '▸' }}</span>
            Evidencias
            <span class="rk-hint-mini">Imagen, PDF, Excel… que respaldan el riesgo y su tratamiento</span>
            <span class="rk-pill" *ngIf="evidencias[r.idRiesgoProceso!]?.length">
              {{ evidencias[r.idRiesgoProceso!].length }} archivo(s)
            </span>
          </button>

          <div class="rk-evd-cuerpo" *ngIf="evidenciasAbiertas.has(r.idRiesgoProceso!)">
            <div class="rk-bit-cargando" *ngIf="cargandoEvidencias.has(r.idRiesgoProceso!)">Consultando…</div>

            <ng-container *ngIf="!cargandoEvidencias.has(r.idRiesgoProceso!)">
              <div class="rk-evd" *ngFor="let evd of evidencias[r.idRiesgoProceso!]">
                <span class="rk-evd-ico">{{ iconoEvidencia(evd) }}</span>
                <div class="rk-evd-txt">
                  <span class="rk-evd-nombre">{{ evd.nombreArchivo }}</span>
                  <span class="rk-evd-meta">
                    {{ tamanoLegible(evd.tamanioBytes) }} · {{ evd.fechaCarga | fechaBitacora }}
                    <ng-container *ngIf="evd.usuarioNombre">· {{ evd.usuarioNombre }}</ng-container>
                    <span class="rk-evd-corte-tag" *ngIf="corteDe(evd)">{{ corteDe(evd) }}</span>
                  </span>
                </div>
                <span class="rk-espacio"></span>
                <button type="button" class="rk-btn-sec mini" (click)="verEvidencia(evd)">Ver</button>
                <button type="button" class="rk-btn-sec mini" (click)="guardarEvidencia(evd)">Descargar</button>
                <button *ngIf="puedeEditar" type="button" class="rk-btn-rojo mini" (click)="eliminarEvidencia(r, evd)"
                        [disabled]="!enEdicion(r)" [title]="avisoSoloEdicion(r)">Eliminar</button>
              </div>

              <div class="rk-bit-vacio"
                   *ngIf="!evidencias[r.idRiesgoProceso!] || evidencias[r.idRiesgoProceso!].length === 0">
                Sin evidencias adjuntas. Lo que se suba aquí queda ligado al riesgo y aparece en su expediente.
              </div>

              <div class="rk-evd-pie">
                <!-- A qué corte respalda. Opcional: hay evidencia que
                     respalda al riesgo en general (una política, un
                     procedimiento) y no a un corte concreto. -->
                <label class="rk-evd-corte" *ngIf="r.seguimientos && r.seguimientos.length">
                  <span>Respalda el corte</span>
                  <select class="i" [(ngModel)]="corteEvidencia[r.idRiesgoProceso!]"
                          [disabled]="!enEdicion(r)" [title]="avisoSoloEdicion(r)">
                    <option [ngValue]="null">Todo el riesgo (sin corte)</option>
                    <option *ngFor="let s of r.seguimientos" [ngValue]="s.idRpSeguimiento">
                      {{ s.fechaMonitoreo | date: 'dd/MM/yyyy' }}
                    </option>
                  </select>
                </label>
                <label class="rk-evd-subir" *ngIf="puedeEditar" [class.off]="!enEdicion(r)"
                       [title]="avisoSoloEdicion(r)">
                  <input type="file" hidden
                         accept=".pdf,.jpg,.jpeg,.png,.gif,.webp,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.csv,.txt,.zip,.mp4,.msg,.eml"
                         (change)="subirEvidencia(r, $event)"
                         [disabled]="!enEdicion(r) || subiendoEvidencia.has(r.idRiesgoProceso!)">
                  <span class="rk-btn-sec mini">
                    {{ subiendoEvidencia.has(r.idRiesgoProceso!) ? 'Subiendo…' : '+ Subir evidencia' }}
                  </span>
                </label>
                <!-- Solo sin archivos: "no aplica" nunca esconde evidencia existente. -->
                <button type="button" class="rk-evd-btn-na"
                        *ngIf="puedeEditar && (!evidencias[r.idRiesgoProceso!] || evidencias[r.idRiesgoProceso!].length === 0)"
                        (click)="marcarNoAplicaEvidencias(r)"
                        [disabled]="!enEdicion(r)" [title]="avisoSoloEdicion(r)">
                  Marcar como No aplica
                </button>
                <span class="rk-evd-solo-lectura" *ngIf="!enEdicion(r)">
                  Para subir o borrar evidencias, da clic en <b>Editar</b> arriba en esta tarjeta.
                </span>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="rk-bitacora" *ngIf="expandido(r)">
          <button type="button" class="rk-cortes-toggle" (click)="alternarRespaldos(r)">
            <span class="rk-caret">{{ respaldosAbiertos.has(r.idRiesgoProceso!) ? '▾' : '▸' }}</span>
            Copias de seguridad
            <span class="rk-hint-mini">Versiones anteriores, para regresar</span>
          </button>

          <div class="rk-bit-lista" *ngIf="respaldosAbiertos.has(r.idRiesgoProceso!)">
            <div class="rk-bit-cargando" *ngIf="cargandoRespaldos.has(r.idRiesgoProceso!)">Cargando…</div>

            <ng-container *ngIf="!cargandoRespaldos.has(r.idRiesgoProceso!)">
              <div class="rk-bit-vacio" *ngIf="!respaldos[r.idRiesgoProceso!]?.length">
                Todavía no hay copias. Se guarda una cada vez que el riesgo cambia o se elimina.
              </div>

              <!-- Reusa las clases de la bitacora para heredar los temas. -->
              <div class="rk-bit rk-resp" *ngFor="let c of respaldos[r.idRiesgoProceso!]">
                <div class="rk-bit-cuerpo-txt">
                  <div class="rk-bit-cab">
                    <strong>{{ motivoRespaldo(c) }}</strong>
                    <span class="rk-bit-quien" *ngIf="c.usuarioNombre">{{ c.usuarioNombre }}</span>
                    <span class="rk-bit-quien sin" *ngIf="!c.usuarioNombre">Sistema</span>
                    <span class="rk-bit-fecha">{{ c.fecha | fechaBitacora }}</span>
                  </div>
                  <div class="rk-bit-valores" *ngIf="c.resumen">
                    <span class="rk-bit-antes">{{ c.resumen }}</span>
                  </div>
                </div>
                <div class="rk-resp-botones" *ngIf="puedeEditar">
                  <button type="button" class="rk-btn-sec mini" (click)="abrirComparacion(r, c)">
                    Comparar
                  </button>
                  <button type="button" class="rk-btn-sec mini"
                          (click)="restaurarRespaldo(r, c)"
                          [disabled]="restaurando.has(r.idRiesgoProceso!)">
                    {{ restaurando.has(r.idRiesgoProceso!) ? 'Restaurando…' : 'Regresar a esta' }}
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="rk-bitacora" *ngIf="expandido(r)">
          <button type="button" class="rk-cortes-toggle" (click)="alternarBitacora(r)">
            <span class="rk-caret">{{ bitacoraAbierta.has(r.idRiesgoProceso!) ? '▾' : '▸' }}</span>
            Bitácora de cambios
            <span class="rk-hint-mini">Quién cambió qué y cuándo</span>
          </button>

          <div class="rk-bit-lista" *ngIf="bitacoraAbierta.has(r.idRiesgoProceso!)">
            <div class="rk-bit-cargando" *ngIf="cargandoBitacora.has(r.idRiesgoProceso!)">Cargando…</div>

            <ng-container *ngIf="!cargandoBitacora.has(r.idRiesgoProceso!)">
              <div class="rk-bit-vacio" *ngIf="!bitacora[r.idRiesgoProceso!]?.length">
                Sin movimientos registrados.
              </div>

              <div class="rk-bit" *ngFor="let h of bitacora[r.idRiesgoProceso!]">
                <span class="rk-bit-accion" [ngClass]="claseAccion(h.accion)">{{ h.accion }}</span>
                <div class="rk-bit-cuerpo-txt">
                  <div class="rk-bit-cab">
                    <strong *ngIf="campo(h)">{{ campo(h) }}</strong>
                    <span class="rk-bit-quien" *ngIf="h.usuarioNombre">{{ h.usuarioNombre }}</span>
                    <span class="rk-bit-quien sin" *ngIf="!h.usuarioNombre">{{ quien(h) }}</span>
                    <span class="rk-bit-fecha">{{ h.fechaCambio | fechaBitacora }}</span>
                  </div>
                  <div class="rk-bit-valores" *ngIf="h.valorAnterior || h.valorNuevo">
                    <span class="rk-bit-antes" *ngIf="h.valorAnterior">{{ h.valorAnterior }}</span>
                    <span class="rk-bit-flecha" *ngIf="h.valorAnterior && h.valorNuevo">&rarr;</span>
                    <span class="rk-bit-nuevo" *ngIf="h.valorNuevo">{{ h.valorNuevo }}</span>
                  </div>
                </div>
                <!-- Desde la propia bitácora se vuelve a cualquier versión.
                     Sólo aparece si de ese movimiento se guardó copia. -->
                <button type="button" class="rk-btn-sec mini"
                        *ngIf="puedeEditar && h.idRespaldo"
                        (click)="restaurarDesdeBitacora(r, h)"
                        [disabled]="restaurando.has(r.idRiesgoProceso!)"
                        matTooltip="Regresa el riesgo a como estaba justo antes de este movimiento.">
                  {{ restaurando.has(r.idRiesgoProceso!) ? 'Restaurando…' : 'Regresar a antes' }}
                </button>
              </div>
            </ng-container>
          </div>
        </div>
    </div>

   </div>
  </ng-container>

  <!-- La alta y la edición comparten este formulario. -->
  <ng-template #formulario let-b>
    <div class="rk-form">

      <label class="rk-campo doble">
        <span class="rk-et">Descripción del riesgo <b class="oblig">*</b></span>
        <textarea class="i ta" rows="2" [maxlength]="lim.riesgo.descripcion" [(ngModel)]="b.descripcion"
                  placeholder="Qué puede pasar y por qué es un riesgo"></textarea>
      </label>

      <label class="rk-campo doble">
        <span class="rk-et">Causa raíz — ¿qué lo origina?</span>
        <textarea class="i ta" rows="2" [maxlength]="lim.riesgo.causaRaiz" [(ngModel)]="b.causaRaiz"></textarea>
      </label>

      <div class="rk-eval doble">
        <div class="rk-eval-caja">
          <div class="rk-eval-tit">Al detectarlo</div>
          <div class="rk-eval-selects">
            <label>
              <span class="rk-et">Probabilidad</span>
              <select class="i" [(ngModel)]="b.probInicial">
                <option [ngValue]="undefined"></option>
                <option *ngFor="let s of severidadPor('PROBABILIDAD')" [ngValue]="s.nivel"
                        [title]="s.descripcion">{{ s.etiqueta }} ({{ s.nivel }})</option>
              </select>
            </label>
            <label>
              <span class="rk-et">Impacto</span>
              <select class="i" [(ngModel)]="b.impactoInicial">
                <option [ngValue]="undefined"></option>
                <option *ngFor="let s of severidadPor('IMPACTO')" [ngValue]="s.nivel"
                        [title]="s.descripcion">{{ s.etiqueta }} ({{ s.nivel }})</option>
              </select>
            </label>
          </div>
          <div class="rk-eval-fila">
            <span class="rk-sev"
                  [ngClass]="claseSeveridad(bandaViva(severidad(b.probInicial, b.impactoInicial)))">
              <span class="rk-sev-num">{{ severidad(b.probInicial, b.impactoInicial) || '—' }}</span>
              <span class="rk-sev-de">de 16</span>
            </span>
            <span class="rk-eval-banda">
              {{ etiquetaBanda(bandaViva(severidad(b.probInicial, b.impactoInicial))) || 'Por calcular' }}
            </span>
          </div>
        </div>

        <div class="rk-flecha"><span class="rk-flecha-simbolo">&rarr;</span></div>

        <div class="rk-eval-caja azul">
          <div class="rk-eval-tit">Tras el plan</div>
          <div class="rk-eval-selects">
            <label>
              <span class="rk-et">Probabilidad</span>
              <select class="i" [(ngModel)]="b.probReevaluada">
                <option [ngValue]="undefined"></option>
                <option *ngFor="let s of severidadPor('PROBABILIDAD')" [ngValue]="s.nivel"
                        [title]="s.descripcion">{{ s.etiqueta }} ({{ s.nivel }})</option>
              </select>
            </label>
            <label>
              <span class="rk-et">Impacto</span>
              <select class="i" [(ngModel)]="b.impactoReevaluado">
                <option [ngValue]="undefined"></option>
                <option *ngFor="let s of severidadPor('IMPACTO')" [ngValue]="s.nivel"
                        [title]="s.descripcion">{{ s.etiqueta }} ({{ s.nivel }})</option>
              </select>
            </label>
          </div>
          <div class="rk-eval-fila">
            <span class="rk-sev"
                  [ngClass]="claseSeveridad(bandaViva(severidad(b.probReevaluada, b.impactoReevaluado)))">
              <span class="rk-sev-num">{{ severidad(b.probReevaluada, b.impactoReevaluado) || '—' }}</span>
              <span class="rk-sev-de">de 16</span>
            </span>
            <span class="rk-eval-banda">
              {{ etiquetaBanda(bandaViva(severidad(b.probReevaluada, b.impactoReevaluado))) || 'Por reevaluar' }}
            </span>
          </div>
        </div>
      </div>

      <label class="rk-campo">
        <span class="rk-et">Estrategia</span>
        <select class="i" [(ngModel)]="b.estrategia">
          <option [ngValue]="undefined"></option>
          <option *ngFor="let e of estrategias" [ngValue]="e">{{ e }}</option>
        </select>
      </label>

      <label class="rk-campo">
        <span class="rk-et">Fecha de identificación</span>
        <input type="date" class="i" [ngModel]="b.fechaIdentificacion | date: 'yyyy-MM-dd'"
               (ngModelChange)="b.fechaIdentificacion = $event" />
      </label>

      <label class="rk-campo">
        <span class="rk-et">Periodicidad de monitoreo</span>
        <input class="i" [maxlength]="lim.riesgo.periodicidad" [(ngModel)]="b.periodicidad" placeholder="Cuatrimestral (cada 4 meses)" />
      </label>

      <label class="rk-campo">
        <span class="rk-et">Fase de detección</span>
        <input class="i" [maxlength]="lim.riesgo.faseDeteccion" [(ngModel)]="b.faseDeteccion" placeholder="NA" />
      </label>

      <label class="rk-campo doble">
        <span class="rk-et">Plan de acción</span>
        <textarea class="i ta" rows="2" [maxlength]="lim.riesgo.acciones" [(ngModel)]="b.acciones"></textarea>
      </label>

      <label class="rk-campo doble">
        <span class="rk-et">Responsable / recursos</span>
        <textarea class="i ta" rows="2" [maxlength]="lim.riesgo.responsableRecursos" [(ngModel)]="b.responsableRecursos"></textarea>
      </label>

      <!-- Solo en las matrices que trabajan con activos (TI/IA): en las
           demas areas no hay inventario al que apuntar. -->
      <label class="rk-campo doble" *ngIf="conActivos">
        <span class="rk-et">Activos evaluados (folios separados por coma)</span>
        <input class="i" [maxlength]="lim.riesgo.activosRelacionados" [(ngModel)]="b.activosRelacionados" placeholder="IA-0001, IA-0002" />
      </label>

    </div>
  </ng-template>

  <!-- ==================== Vista previa formato FOS-005 ==================== -->
  <ng-container *ngIf="vistaPrevia">

    <div class="rk-barra">
      <div>
        <strong>Formato FOS-005 — vista previa</strong>
        <span class="rk-hint">
          Así se ve la hoja «Plan Gestión RSK» en el Excel oficial. Solo lectura:
          para editar, cierra esta vista y usa las tarjetas.
        </span>
      </div>
      <div class="rk-acciones">
        <button type="button" class="rk-btn-cerrar" (click)="alternarVista()">
          ✕ Cerrar
        </button>
      </div>
    </div>

    <div class="rk-scroll">
      <!-- El ancho crece con las parejas de monitoreo, igual que en el Excel. -->
      <table class="rk-tabla" [style.width]="anchoFormato">
        <colgroup>
          <col class="w-id" />
          <col class="w-fase" />
          <col class="w-texto" />
          <col class="w-texto" />
          <col class="w-nivel" /><col class="w-nivel" />
          <col class="w-sev" /><col class="w-clas" />
          <col class="w-estrategia" />
          <col class="w-fecha" />
          <col class="w-period" />
          <col class="w-texto" />
          <col class="w-persona" />
          <col class="w-nivel" /><col class="w-nivel" />
          <col class="w-sev" /><col class="w-clas" />
          <ng-container *ngFor="let p of paresMonitoreo">
            <col class="w-monfecha" /><col class="w-monres" />
          </ng-container>
        </colgroup>

        <thead>
          <!-- Los title son las notas que en el Excel salían al pasar el mouse. -->
          <tr>
            <th rowspan="2" class="fija nota" [title]="notas['idRiesgo']">ID Riesgo</th>
            <th rowspan="2" class="nota" [title]="notas['faseDeteccion']">Fase de detección</th>
            <th rowspan="2" class="nota" [title]="notas['descripcionRiesgo']">Descripción del Riesgo</th>
            <th rowspan="2" class="nota" [title]="notas['causaRaiz']">
              Causa Raíz<br><span class="th-sub">¿Qué lo origina?</span>
            </th>
            <th colspan="4" class="c nota"
                title="Cómo se evaluó el riesgo cuando se detectó, antes de aplicar el plan de acción.">
              Evaluación inicial <span class="th-esc linea">(al detectarlo)</span>
            </th>
            <th rowspan="2" class="nota" [title]="notas['estrategia']">Estrategia</th>
            <th rowspan="2" class="nota" [title]="notas['fechaIdentificacion']">Fecha de<br>Identificación</th>
            <th rowspan="2" class="nota"
                title="Cada cuánto toca revisar este riesgo y registrar un corte de seguimiento.">
              Periodicidad<br><span class="th-sub">de monitoreo</span>
            </th>
            <th rowspan="2" class="nota" [title]="notas['acciones']">Acciones a seguir</th>
            <th rowspan="2" class="nota" [title]="notas['responsable']">Responsable / Recursos</th>
            <th colspan="4" class="c nota"
                title="Cómo queda el riesgo una vez aplicado el plan de acción. Si el plan sirve, la severidad baja de banda.">
              Reevaluación <span class="th-esc linea">(tras el plan)</span>
            </th>
            <!-- Una pareja de columnas por ciclo de monitoreo, y así sucesivamente. -->
            <ng-container *ngFor="let p of paresMonitoreo; let i = index">
              <th rowspan="2" class="c nota"
                  title="Se agrega una pareja de columnas —fecha y resultado— por cada ciclo de monitoreo, y así sucesivamente.">
                Fecha de Monitoreo<br>y reevaluación
                <span class="th-esc">corte {{ i + 1 }}</span>
              </th>
              <th rowspan="2">Resultado</th>
            </ng-container>
          </tr>
          <tr>
            <th scope="col" class="c mini nota" [title]="notas['probabilidad']">
              Probabilidad<span class="th-esc">1 a 4</span>
            </th>
            <th scope="col" class="c mini nota" [title]="notas['impacto']">
              Impacto<span class="th-esc">1 a 4</span>
            </th>
            <th scope="col" class="c mini nota" [title]="notas['severidad']">
              Severidad<span class="th-esc">1 a 16</span>
            </th>
            <th scope="col" class="c mini nota"
                title="La banda en la que cae la severidad: Baja, Media, Alta o Crítico. Es la que define si el riesgo se acepta y cada cuánto se comprueba.">
              Clasificación
            </th>
            <th scope="col" class="c mini nota" [title]="notas['probabilidad']">
              Probabilidad<span class="th-esc">1 a 4</span>
            </th>
            <th scope="col" class="c mini nota" [title]="notas['impacto']">
              Impacto<span class="th-esc">1 a 4</span>
            </th>
            <th scope="col" class="c mini nota" [title]="notas['severidad']">
              Severidad<span class="th-esc">1 a 16</span>
            </th>
            <th scope="col" class="c mini nota"
                title="La banda en la que cae la severidad reevaluada. Comparada con la inicial, es lo que demuestra que el plan de acción sirvió.">
              Clasificación
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of riesgos">
            <td class="c nw fija"><strong>{{ r.consecutivo }}</strong></td>
            <td>{{ r.faseDeteccion }}</td>
            <td class="ancha">{{ r.descripcion }}</td>
            <td class="ancha">{{ r.causaRaiz }}</td>
            <td class="c">{{ etiqueta('PROBABILIDAD', r.probInicial) }}</td>
            <td class="c">{{ etiqueta('IMPACTO', r.impactoInicial) }}</td>
            <!-- title nativo y no matTooltip: el tooltip de Material se dibuja en el
                 overlay del CDK, que queda debajo de esta vista a pantalla completa. -->
            <td class="c calc">
              <span class="chip" [ngClass]="claseSeveridad(r.clasificacionInicial)"
                    [title]="r.criterioAceptacion || ''">{{ r.severidadInicial }}</span>
              <div class="rk-de">de 16</div>
            </td>
            <td class="c calc">{{ r.clasificacionInicial }}</td>
            <td class="c">{{ r.estrategia }}</td>
            <td class="c nw">{{ r.fechaIdentificacion | date: 'dd/MM/yyyy' }}</td>
            <td class="c">{{ r.periodicidad }}</td>
            <td class="ancha">{{ r.acciones }}</td>
            <td class="ancha">{{ r.responsableRecursos }}</td>
            <td class="c">{{ etiqueta('PROBABILIDAD', r.probReevaluada) }}</td>
            <td class="c">{{ etiqueta('IMPACTO', r.impactoReevaluado) }}</td>
            <td class="c calc">
              <span class="chip" [ngClass]="claseSeveridad(r.clasificacionReevaluada)">
                {{ r.severidadReevaluada }}
              </span>
              <div class="rk-de">de 16</div>
            </td>
            <td class="c calc">{{ r.clasificacionReevaluada }}</td>
            <ng-container *ngFor="let p of paresMonitoreo; let i = index">
              <td class="c nw" [class.pend]="esPendiente(corte(r, i)?.resultado)">
                {{ (corte(r, i)?.fechaMonitoreo | date: 'dd/MM/yyyy') || '' }}
              </td>
              <td [class.pend]="esPendiente(corte(r, i)?.resultado)">
                {{ corte(r, i)?.resultado }}
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- El seguimiento no lleva bloque aparte: en la hoja vive en las parejas de
         columnas de arriba, y repetirlo aquí seria inventarle una sección que el
         formato no tiene. -->
    <div class="rk-seg">
      <span class="rk-hint">
        El seguimiento son las <b>{{ paresMonitoreo.length }}</b> parejas de columnas del extremo
        derecho de la tabla: una por ciclo de monitoreo, y así sucesivamente conforme se registren.
        Quién capturó cada corte se consulta en las tarjetas, no en el formato.
      </span>
    </div>

  </ng-container>

</div>

<!-- ==================== Confirmación ====================
     Va fuera del contenedor para que quede sobre la vista previa a pantalla
     completa. Se cierra solo con sus botones: ni Esc ni clic en el fondo. -->
<div class="rk-conf-fondo" *ngIf="confirma">
  <div class="rk-conf" role="alertdialog" aria-modal="true">
    <div class="rk-conf-icono">!</div>
    <h3 class="rk-conf-titulo">{{ confirma.titulo }}</h3>
    <p class="rk-conf-texto">{{ confirma.texto }}</p>
    <p class="rk-conf-detalle" *ngIf="confirma.detalle">{{ confirma.detalle }}</p>
    <div class="rk-conf-botones">
      <button type="button" class="rk-conf-no" (click)="confirmarNo()">No</button>
      <button type="button" class="rk-conf-si" (click)="confirmarSi()">{{ confirma.botonSi }}</button>
    </div>
  </div>
</div>

<!-- ==================== Criterios de evaluación ====================
     Los tres bloques del formato: probabilidad, impacto y las bandas de
     severidad con su criterio de aceptación. Se arma con los catálogos que ya
     están cargados —los mismos con los que el backend calcula—, así que no
     puede decir una cosa y el sistema hacer otra.
     Se cierra sólo con su botón. -->
<div class="rk-cri-fondo" *ngIf="criterios">
  <div class="rk-cri" role="dialog" aria-modal="true" aria-label="Criterios de evaluación">
    <div class="rk-cri-cab">
      <div>
        <strong>Criterios para evaluación de riesgos</strong>
        <span class="rk-cri-sub">
          La severidad es <b>probabilidad &times; impacto</b>, en escala de 1 a 16.
        </span>
      </div>
      <button type="button" class="rk-btn-cerrar" (click)="cerrarCriterios()">✕ Cerrar</button>
    </div>

    <div class="rk-cri-cuerpo">
      <div class="rk-cri-cols">
        <div class="rk-cri-caja">
          <div class="rk-cri-tit">Probabilidad</div>
          <table class="rk-cri-tabla">
            <!-- Encabezado sólo para lectores de pantalla: a la vista lo da el título de la caja. -->
            <thead class="cdk-visually-hidden">
              <tr><th scope="col">Probabilidad</th><th scope="col">Nivel</th></tr>
            </thead>
            <tr *ngFor="let s of severidadPor('PROBABILIDAD')">
              <td>{{ s.etiqueta }}</td>
              <td class="n">{{ s.nivel }}</td>
            </tr>
          </table>
        </div>

        <div class="rk-cri-caja">
          <div class="rk-cri-tit">Impacto</div>
          <table class="rk-cri-tabla">
            <!-- Encabezado sólo para lectores de pantalla: a la vista lo da el título de la caja. -->
            <thead class="cdk-visually-hidden">
              <tr><th scope="col">Impacto</th><th scope="col">Nivel</th></tr>
            </thead>
            <tr *ngFor="let s of severidadPor('IMPACTO')">
              <td>{{ s.etiqueta }}</td>
              <td class="n">{{ s.nivel }}</td>
            </tr>
          </table>
        </div>

        <div class="rk-cri-caja ancho">
          <div class="rk-cri-tit">Severidad del riesgo y criterio de aceptación</div>
        <table class="rk-cri-tabla bandas">
          <thead>
            <tr>
              <th>Severidad</th>
              <th class="n">Probabilidad &times; impacto</th>
              <th>Criterio de aceptación</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of clasificaciones" [ngClass]="claseCriterio(c.clasificacion)">
              <td class="banda">{{ etiquetaBanda(c.clasificacion) }}</td>
              <td class="n">{{ rangoBanda(c) }}</td>
              <td class="criterio">{{ c.criterioAceptacion }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <p class="rk-cri-pie">
        Estos valores salen del catálogo del sistema, que es el mismo con el que
        se calcula la severidad de cada riesgo. Coinciden con el formato FOS-005.
      </p>
    </div>
  </div>

  <!-- Expediente del riesgo: reune su plan de accion, sus cortes, sus
       evidencias y su bitacora en una ventana de solo lectura. Solo se llega
       aqui desde las matrices sin activos. El componente se cuelga solo de
       <body>. -->
  <app-expediente-riesgo-ia *ngIf="expediente" [riesgo]="expediente" [matriz]="matriz"
                            (cerrar)="cerrarExpediente()"></app-expediente-riesgo-ia>

  <!-- ==================== Comparar versiones ====================
       Una copia enfrentada contra el riesgo de hoy. Sólo lectura: se cierra
       con Escape, con el botón o pulsando el fondo, que aquí no cuesta nada
       porque no hay nada capturado que perder. -->
  <div class="rk-cmp-fondo" *ngIf="comparaRiesgo" (click)="cerrarComparacion()" (keydown.enter)="cerrarComparacion()">
    <div class="rk-cmp" role="dialog" aria-modal="true"
         aria-label="Comparación de versiones" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">

      <div class="rk-cmp-cab">
        <div class="rk-cmp-cab-txt">
          <strong>Comparar versiones</strong>
          <span class="rk-cmp-sub" *ngIf="comparacion">
            {{ comparacion.referencia }} · {{ comparacion.titulo }}
          </span>
        </div>
        <button type="button" class="rk-cmp-cerrar" (click)="cerrarComparacion()">✕ Cerrar</button>
      </div>

      <div class="rk-cmp-lados">
        <div class="rk-cmp-lado">
          <span class="rk-cmp-lado-et">Versión anterior</span>
          <!-- ngModel de una via y no [value]: el binding del <select> se evalua
               ANTES de que el *ngFor cree sus <option>, y la seleccion se perdia. -->
          <select class="rk-cmp-select" aria-label="Versión anterior" *ngIf="comparaVersiones.length > 1"
                  [disabled]="comparando"
                  [ngModel]="comparaIdRespaldo"
                  (ngModelChange)="comparaOtraVersion($event)">
            <option *ngFor="let v of comparaVersiones" [ngValue]="v.idRespaldo">
              {{ v.fecha | fechaBitacora }} · {{ motivoRespaldo(v) }}{{ v.usuarioNombre ? ' · ' + v.usuarioNombre : '' }}
            </option>
          </select>
          <span class="rk-cmp-lado-val" *ngIf="comparaVersiones.length <= 1 && comparacion">
            {{ comparacion.etiquetaAntes }}
          </span>
        </div>
        <span class="rk-cmp-vs">contra</span>
        <div class="rk-cmp-lado">
          <span class="rk-cmp-lado-et">Versión actual</span>
          <span class="rk-cmp-lado-val" *ngIf="comparacion">{{ comparacion.etiquetaDespues }}</span>
        </div>
      </div>

      <div class="rk-cmp-cuerpo">
        <div class="rk-bit-cargando" *ngIf="comparando">Comparando…</div>

        <ng-container *ngIf="!comparando && comparacion">
          <div class="rk-cmp-aviso" *ngIf="!comparacion.existeActual">
            Este riesgo ya no existe en el plan: se eliminó y no se ha restaurado.
            Lo que sigue es todo lo que traía la copia.
          </div>

          <div class="rk-cmp-marcador">
            <span class="rk-cmp-tot cmp-alta" *ngIf="comparacion.agregados">
              {{ comparacion.agregados }} nuevo{{ comparacion.agregados === 1 ? '' : 's' }}
            </span>
            <span class="rk-cmp-tot cmp-baja" *ngIf="comparacion.eliminados">
              {{ comparacion.eliminados }} quitado{{ comparacion.eliminados === 1 ? '' : 's' }}
            </span>
            <!-- "campos" a proposito: los de arriba cuentan bloques enteros
                 (una amenaza que nace o se va) y este cuenta campos sueltos.
                 Sin decirlo, los tres numeros parecian de la misma cosa. -->
            <span class="rk-cmp-tot cmp-cambio" *ngIf="comparacion.cambiados">
              {{ comparacion.cambiados }} campo{{ comparacion.cambiados === 1 ? '' : 's' }} cambiado{{ comparacion.cambiados === 1 ? '' : 's' }}
            </span>
            <span class="rk-cmp-tot cmp-igual" *ngIf="comparacion.sinCambios">
              Sin diferencias: la copia y la versión de hoy son iguales
            </span>
            <button type="button" class="rk-cmp-filtro" (click)="alternarSoloCambios()">
              {{ comparaSoloCambios ? 'Ver también lo que no cambió' : 'Ver sólo lo que cambió' }}
            </button>
          </div>

          <div class="rk-cmp-grupo" *ngFor="let v of comparaVista"
               [ngClass]="'n' + v.grupo.nivel">
            <div class="rk-cmp-grupo-cab">
              <span class="rk-cmp-marca" [ngClass]="claseComparacion(v.grupo.estado)">
                {{ etiquetaComparacion(v.grupo.estado) }}
              </span>
              <strong>{{ v.grupo.titulo }}</strong>
              <span class="rk-cmp-ctx" *ngIf="v.grupo.contexto">{{ v.grupo.contexto }}</span>
            </div>

            <div class="rk-cmp-renglon" *ngFor="let r of v.renglones"
                 [ngClass]="claseRenglonComparacion(r.estado)">
              <span class="rk-cmp-campo">
                {{ r.etiqueta }}
                <span class="rk-cmp-calc" *ngIf="r.calculado" matTooltip="Sale de una fórmula: cambia porque cambiaron sus insumos">ƒ</span>
              </span>
              <span class="rk-cmp-valores">
                <span class="rk-cmp-antes" *ngIf="r.antes">{{ r.antes }}</span>
                <span class="rk-cmp-nada" *ngIf="!r.antes">—</span>
                <span class="rk-cmp-flecha">&rarr;</span>
                <span class="rk-cmp-despues" *ngIf="r.despues">{{ r.despues }}</span>
                <span class="rk-cmp-nada" *ngIf="!r.despues">—</span>
              </span>
            </div>

            <div class="rk-bit-vacio" *ngIf="v.renglones.length === 0">
              Sin cambios en este bloque.
            </div>
          </div>

          <div class="rk-cmp-pie" *ngIf="comparaOcultos > 0 && comparaSoloCambios">
            Se ocultaron {{ comparaOcultos }} bloque{{ comparaOcultos === 1 ? '' : 's' }} sin cambios.
          </div>
        </ng-container>
      </div>
    </div>
  </div>

</div>
